{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"__experimental": true,
	"name": "core/playlist",
	"title": "Playlist",
	"category": "media",
	"description": "Embed a simple playlist.",
	"keywords": [ "music", "sound" ],
	"textdomain": "default",
	"allowedBlocks": [ "core/playlist-track" ],
	"attributes": {
		"currentTrack": {
			"type": "string"
		},
		"type": {
			"type": "string",
			"default": "audio"
		},
		"order": {
			"type": "string",
			"default": "asc"
		},
		"showTracklist": {
			"type": "boolean",
			"default": true
		},
		"showImages": {
			"type": "boolean",
			"default": true
		},
		"showArtists": {
			"type": "boolean",
			"default": true
		},
		"showNumbers": {
			"type": "boolean",
			"default": true
		},
		"showTrackLength": {
			"type": "boolean",
			"default": true
		},
		"caption": {
			"type": "string"
		}
	},
	"providesContext": {
		"showArtists": "showArtists",
		"currentTrack": "currentTrack"
	},
	"supports": {
		"anchor": true,
		"align": true,
		"color": {
			"gradients": true,
			"link": true,
			"__experimentalDefaultControls": {
				"background": true,
				"text": true
			}
		},
		"__experimentalBorder": {
			"color": true,
			"radius": true,
			"style": true,
			"width": true,
			"__experimentalDefaultControls": {
				"color": true,
				"radius": true,
				"style": true,
				"width": true
			}
		},
		"interactivity": true,
		"spacing": {
			"margin": true,
			"padding": true
		}
	},
	"styles": [
		{ "name": "bars", "label": "Bars", "isDefault": true },
		{ "name": "mirror", "label": "Mirror" },
		{ "name": "line", "label": "Line" },
		{ "name": "blocks", "label": "Blocks" },
		{ "name": "dots", "label": "Dots" },
		{ "name": "seekbar", "label": "Seekbar" }
	],
	"editorStyle": "wp-block-playlist-editor",
	"style": "wp-block-playlist"
}
